export default __webpack_public_path__ + "static/beach-seychelles-0d0b8a52585334484778bbbfc20bc5d6.jpg";